export default {"src":"https://gfiber.com/support/_next/static/media/tool-tip-info.7ed2ab2a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};